import React from "react";
import { AWARDS } from "../../mock";
import { Award, Trophy } from "lucide-react";
import { SectionTitle } from "./About";

export default function Awards() {
  const all = [...AWARDS, ...AWARDS]; // duplicate for marquee loop
  return (
    <section id="awards" className="scroll-smooth-section py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTitle
          kicker="Recognition"
          title="Forty-two awards — and counting"
          subtitle="Honoured for contributions to rural health, medical education, literature and philanthropy. Best Tax Payer of Thiruvananthapuram (1999) by the Income Tax Department."
        />
      </div>

      <div className="mt-14 marquee">
        <div className="marquee-track">
          {all.map((a, i) => (
            <div key={i} className="flex items-center gap-3 bg-ivory border border-stone-200 rounded-full px-5 py-3 shadow-sm">
              <div className="w-8 h-8 rounded-full bg-gold/20 flex items-center justify-center">
                <Trophy className="w-4 h-4 text-gold" />
              </div>
              <span className="text-sm text-stone-700 whitespace-nowrap">{a}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 lg:px-8 mt-14 grid md:grid-cols-3 gap-6">
        {[
          { num: "42+", label: "Awards Received", text: "Across rural health, medical education, charity and literature.", bg: "bg-gradient-to-br from-emerald-deep via-teal to-emerald-deep", accent: "text-champagne" },
          { num: "1999", label: "Best Tax Payer", text: "Recognised by Income Tax Department, Thiruvananthapuram.", bg: "bg-gradient-to-br from-coral to-saffron", accent: "text-white" },
          { num: "15", label: "Books Authored", text: "In English, Malayalam and Sanskrit — from Neuro Samvadham to Daivadasakam.", bg: "bg-gradient-to-br from-indigoVivid to-plum", accent: "text-champagne" }
        ].map((s, i) => (
          <div key={i} className={`${s.bg} text-white rounded-3xl p-7 lift relative overflow-hidden`}>
            <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-white/10 blur-2xl pointer-events-none" />
            <Award className={`w-8 h-8 ${s.accent}`} />
            <div className={`font-display text-5xl ${s.accent} mt-3 leading-none`}>{s.num}</div>
            <div className="text-[10px] uppercase tracking-[0.3em] mt-2 font-semibold">{s.label}</div>
            <p className="text-white/85 text-sm mt-4 leading-relaxed">{s.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
